import { List } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <List.Root css={{ paddingLeft: '600' }}>
        <List.Item>
          Include details about occupations, hobbies, and interests to help the renter determine if they’ll be a good
          fit.
        </List.Item>
        <List.Item>
          Be sure to mention personal schedules, especially if someone works from home or needs to sleep during the day
          because they work nights.
        </List.Item>
        <List.Item>
          Note any preferences about common activities such as cleaning, cooking, and having guests over.
        </List.Item>
      </List.Root>
    </div>
  );
};

export default WizardTipContent;
